/**
 * Calculates the starting year of the current football season.
 * Football season is assumed to start in August (Month 8).
 * @returns {number} The start year of the current season.
 */
export const getFootballSeasonYear = () => {
  const now = new Date()
  let currentYear = now.getFullYear()
  const currentMonth = now.getMonth() + 1

  // Football season starts in August
  if (currentMonth < 8) {
    currentYear -= 1
  }
  return currentYear
}

/**
 * Generates a list of football seasons.
 * @param {number} count - The number of seasons to generate, going back from the current season.
 * @returns {Array<{value: string, label: string}>} Array of season objects.
 */
export const getSeasons = (count = 4) => {
  const currentYear = getFootballSeasonYear()

  return Array.from({ length: count }, (_, i) => {
    const start = currentYear - i
    const end = start + 1
    return {
      value: `${start}/${end}`,
      label: `${start}-${String(end).slice(-2)}`,
    }
  })
}
